import { toast } from "react-toastify";
import Config from "../config";
import request from "../utils/request2";
const server = Config.siteAddress?Config.siteAddress:"";
export function abnormalPrompt(abnormalText: string, typeCode: string) {
	let toastCode = null
	switch (typeCode) {
		case "success":
			toastCode = toast.success
			break;
		case "warning":
			toastCode = toast.warning
			break;
		default:
			toastCode = toast.error
			break;
	}

	toastCode(
		abnormalText,
		{
			position: toast.POSITION.TOP_CENTER,
			hideProgressBar: true,
			theme: "colored",
		}
	);

	return false
}


export function echoPutBack(item: any) {
	let TipsCode = 'success';

	if (Number(item.resultCode) === 0) {
		TipsCode = 'warning';
	} else if (Number(item.resultCode) === -1) {
		TipsCode = 'danger';
	}

	abnormalPrompt(
		item.resultMsg, // String, HTML or Component
		TipsCode, // "default" || "info" || "warning" || "success" || "danger",
	);
}

function pageMethod(page:any){
	let pageObject:any = {};
	if(page){
		if(page.pageSize){
			pageObject.pageSize = page.pageSize;
		}
		if(page.pageNum){
			pageObject.pageNum = page.pageNum;
		}
		if(page.orderByColumn){
			pageObject.orderByColumn = page.orderByColumn;
		}
		if(page.isAsc){
			pageObject.isAsc = page.isAsc;
		}
		if(page.pageSign){
			pageObject.pageSign = page.pageSign;
		}
	}
	return pageObject;
}

//获取web基本配置信息
export function getConfigsDataList(query: any) {
	
    return request({
      url: server+"/api/",
      method: 'get',
	  params:query
    })
}
//用户登录
export function doLogin(query:any) {
	return request({
		url: server + "/api/system/login",
		method: 'post',
		data: query
	})
}
//单点登录
export function ssoLogin(query:any) {
	return request({
		url: server + "/api/system/ssoLogin",
		method: 'post',
		data: query
	})
}
//退出登录
export function logout() {
	return request({
		url: server + "/api/system/logout",
		method: 'post',
	})
}
//获取用户基本信息
export function getUserEssentialInformation() {
    return request({
      url: server+"/api/system/getInfo",
      method: 'get',
    })
}
//获取系统基本配置信息
export function getConfigsDataBasicList(data: any) {
	//const filterParams = query.filters.map(f => `filters=${(f)}`).join('&');
    return request({
		url: server+"/api/system/config/listSystem",
		method: 'post',
		data
    })
}
//获取系统功能配置信息
export function getConfigsDataSystemList(data: any) {
	//const filterParams = query.filters.map(f => `filters=${(f)}`).join('&');
    return request({
		url: server+"/api/system/config/listSystemBasic",
		method: 'post',
		data
    })
}
//获取系统业务配置信息
export function getConfigsBusinessDataList(data: any) {
	//const filterParams = query.filters.map(f => `filters=${(f)}`).join('&');
    return request({
		url: server+"/api/system/config/listSystemBusiness",
		method: 'post',
		data
    })
}
//查询系统config配置信息
export function getConfigsBySearch(data: any,page:any) {
	let pageData = pageMethod(page);
    return request({
		url: server+"/api/system/configs/getConfigsList",
		method: 'post',
		data:{
			...pageData,
			filters:data
		}
    })
}
//批量修改基本配置信息
export function editConfigs(data: any) {
    return request({
		url: server+"/api/system/configs/editBatchConfigs",
		method: 'post',
		data
    })
}
//批量修改系统配置信息
export function editConfig(data: any) {
    return request({
		url: server+"/api/system/config/editBatchConfig",
		method: 'post',
		data
    })
}
//查询部门和用户
export function getAllUserToDepartment() {
    return request({
		url: server+"/api/system/dept/getDepAndUser",
		method: 'post',
    })
}
//查询部门和用户-排除禁用用户
export function getAllUserToDepartmentNotDis() {
    return request({
		url: server+"/api/system/dept/getDepAndUserByNotDis",
		method: 'post',
    })
}
//文件上传-单文件
export function upload(data:any) {
    return request({
		url: server+"/api/common/upload",
		method: 'post',
		data: data,
		headers: {
            'Content-Type': 'multipart/form-data' // 通常可以省略，因为 FormData 会自动设置
        }
    })
}
//文件上传-多文件
export function uploads(data:any) {
    return request({
		url: server+"/api/common/uploads",
		method: 'post',
		data: data,
		headers: {
            'Content-Type': 'multipart/form-data' // 通常可以省略，因为 FormData 会自动设置
        }
    })
}
//文件下载
export function download(file:any,deleteSign:any) {
	return request({
		url: server+`/api/common/download?fileName=${file}&delete=${deleteSign}`,
		method: 'get',
		responseType: 'blob',
	})
}
//获取授权信息
export function getLicense(){
	return request({
		url: server+"/api/common/getLicense",
		method: 'post',	
	})
}
// 获取菜单列表-条件搜索
export function getMenuBySearch(data: any,page:any) {
	let pageData = pageMethod(page);
	return request({
		//url: server + "/api/Zuad/getMenuBySearch",
		url: server + "/api/system/menu/getMenuList",
		method: 'post',
		data:{
			...pageData,
			filters:data
		}
	})
}
//修改菜单信息
export function editMenu(data: any) {
    return request({
		url: server+"/api/system/menu/editMenuById",
		method: 'post',
		data
    })
}
//根据id删除菜单
export function delMenu(data: any) {
    return request({
		url: server+"/api/system/menu/delMenu",
		method: 'post',
		data
    })
}
//添加菜单信息
export function addMenu(data: any) {
    return request({
		url: server+"/api/system/menu/addMenu",
		method: 'post',
		data
    })
}
//获取角色列表-条件搜索
export function getRoleBySearch(data: any,page:any) {
	let pageData = pageMethod(page);
	return request({
		url: server + "/api/system/role/getRoleList",
		method: 'post',
		data:{
			...pageData,
			filters:data
		}
	})
}
//根据id修改角色数据
export function editRole(data: any) {
    return request({
		url: server+"/api/system/role/editRoleById",
		method: 'post',
		data
    })
}
//根据id删除角色数据
export function delRole(data: any) {
    return request({
		url: server+"/api/system/role/delRole",
		method: 'post',
		data
    })
}
//新增角色数据
export function addRole(data: any) {
    return request({
		url: server+"/api/system/role/addRole",
		method: 'post',
		data
    })
}
//查询操作日志
export function getOperLogBySearch(data: any,page:any) {
	let pageData = pageMethod(page);
	return request({
		//url: server + "/api/Zuad/getMenuBySearch",
		url: server + "/api/system/operlog/getOperLogList",
		method: 'post',
		data:{
			...pageData,
			filters:data
		}
	})
}
//个人重置密码
export function editPassword(data: any) {
    return request({
		url: server+"/api/system/user/resetPasswords",
		method: 'post',
		data
    })
}
//管理员重置密码
export function editCoercePassword(data: any) {
    return request({
		url: server+"/api/system/user/coerceResetPasswords",
		method: 'post',
		data
    })
}
//根据id修改用户数据
export function editUser(data: any) {
    return request({
		url: server+"/api/system/user/editUserById",
		method: 'post',
		data
    })
}
//根据id删除用户数据
export function delUser(data: any) {
    return request({
		url: server+"/api/system/user/delUser",
		method: 'post',
		data
    })
}
//新增用户数据
export function addUser(data: any) {
    return request({
		url: server+"/api/system/user/addUser",
		method: 'post',
		data
    })
}
//批量新增用户
export function addBatchUser(data: any) {
    return request({
		url: server+"/api/system/user/addBatchUser",
		method: 'post',
		data
    })
}
//查询用户列表
export function getUserBySearch(data: any,page:any) {
	let pageData = pageMethod(page);
	return request({
		//url: server + "/api/Zuad/getMenuBySearch",
		url: server + "/api/system/user/getUserList",
		method: 'post',
		data:{
			...pageData,
			filters:data
		}
	})
}
//查询用户列表-排除禁用
export function getUserNotDisBySearch(data: any,page:any) {
	let pageData = pageMethod(page);
	return request({
		//url: server + "/api/Zuad/getMenuBySearch",
		url: server + "/api/system/user/getUserListByDis",
		method: 'post',
		data:{
			...pageData,
			filters:data
		}
	})
}
//查询区域和会议室
export function getAllRoomToArea(data: any) {
    return request({
		url: server+"/api/general/area/getAreaAndRoomWithComplexCondition",
		method: 'post',
		data
    })
}
//查询部门列表
export function getDepBySearch(data: any,page:any) {
	let pageData = pageMethod(page);
	return request({
		//url: server + "/api/Zuad/getMenuBySearch",
		url: server + "/api/system/dept/getDepList",
		method: 'post',
		data:{
			...pageData,
			filters:data
		}
	})
}
//根据id修改部门数据
export function editDep(data: any) {
    return request({
		url: server+"/api/system/dept/editDepById",
		method: 'post',
		data
    })
}
//根据id删除部门数据
export function delDep(data: any) {
    return request({
		url: server+"/api/system/dept/delDep",
		method: 'post',
		data
    })
}
//新增部门数据
export function addDep(data: any) {
    return request({
		url: server+"/api/system/dept/addDep",
		method: 'post',
		data
    })
}
//判断权限
export function verifyPermissionsMethod(permisssionList:any,stringSign:string){
	if(permisssionList.includes("*:*:*")){
		return true;
	}
	return permisssionList.includes(stringSign);
}
//权限访问
export function isJurisdictionMethod(userData:any,signString:any,fieldString:any){
	if(userData.viewPermissions
		||verifyPermissionsMethod(userData.refer,signString)
		||fieldString==userData.id){
			//echoPutBack({resultMsg:"无权限",resultCode:0})
			return true;
	}else{
		return false
	}
}
export function getPrivilegedTimeMethod() {
    return request({
		url: server+"/api/system/config/getPrivilegedTimeMethod",
		method: 'post',
    })
}
//导出用户模板
export function exportUserTemplate() {
    return request({
		url: server+"/api/system/user/exportUserTemplate",
		method: 'post',
    })
}
//导入用户数据
export function importExcelUserName(data:any) {
    return request({
		url: server+"/api/system/user/importUserExcel",
		method: 'post',
		data
    })
}
//查询流程列表
export function getWorkFlowList(data: any,page:any) {
	let pageData = pageMethod(page);
	return request({
		//url: server + "/api/Zuad/getMenuBySearch",
		url: server + "/api/system/workflow/getApprovalEntryList",
		method: 'post',
		data:{
			...pageData,
			filters:data
		}
	})
}
//根据id修改流程数据
export function editApprovalEntry(data: any) {
    return request({
		url: server+"/api/system/workflow/editApprovalEntry",
		method: 'post',
		data
    })
}
//根据id删除流程数据
export function delApprovalEntry(data: any) {
    return request({
		url: server+"/api/system/workflow/delApprovalEntry",
		method: 'post',
		data
    })
}
//新增流程数据
export function addApprovalEntry(data: any) {
    return request({
		url: server+"/api/system/workflow/addApprovalEntry",
		method: 'post',
		data
    })
}
//查询子流程列表
export function getFlowList(data: any) {
    return request({
		url: server+"/api/system/workflow/getFlowList",
		method: 'post',
		data
    })
}
//批量添加子流程
export function addWorkflowFlowBatch(data: any) {
    return request({
		url: server+"/api/system/workflow/addWorkflowFlowBatch",
		method: 'post',
		data
    })
}